import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import { VideoInfoProps } from '@widgets/Teaser/toi/types'
import SvgIcon from '@components/SvgIcon'

type StyledVideoInfoProps = Pick<
  VideoInfoProps,
  'isStandalone' | 'isInPromo' | 'isOpinion'
>

const StyledVideoInfo = styled.div<StyledVideoInfoProps>`
  display: inline-grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;
  ${({ isStandalone, isInPromo, isOpinion }) => {
    if (isStandalone) {
      return css`
        position: absolute;
        top: ${isInPromo ? '16px' : '8px'};
        right: ${isInPromo ? '16px' : '8px'};
      `
    } else {
      return css`
        position: relative;
        margin-bottom: ${isOpinion ? '10px' : '0px'};
      `
    }
  }};
`

const StyledVideoIconWrapper = styled.div`
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  line-height: 0;
  align-self: center;
  justify-self: center;
  background-color: ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => brand_55};
`

const StyledVideoDuration = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        blicktvGrey: { btvGrey_100 },
        white,
      },
    },
  }) => css`
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    padding: 0 3px;
    background-color: ${btvGrey_100};
    color: ${white};
    font-size: 14px;
    line-height: 19px;
    align-self: center;
    justify-self: center;
    font-family: ${sourceSansPro};
  `}
`

const VideoInfo: FunctionComponent<VideoInfoProps> = ({
  isStandalone,
  isInPromo,
  isOpinion,
  children,
}) => {
  const theme = useTheme()
  return (
    <>
      <StyledVideoInfo
        isStandalone={isStandalone}
        isInPromo={isInPromo}
        isOpinion={isOpinion}>
        <StyledVideoIconWrapper>
          <SvgIcon iconName="video-play" size={19} color={theme.colors.white} />
        </StyledVideoIconWrapper>
        <StyledVideoDuration>{children}</StyledVideoDuration>
      </StyledVideoInfo>
      {isOpinion && !isStandalone ? <div /> : null}
    </>
  )
}

export default VideoInfo
